// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedOrderDetailsTotalStyles } from "@conklin/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsTotal";
import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

savedOrderDetailsTotalStyles.buttonWrapper = {
    css: css`
        width: 100%;
        margin-top: 16px;
        padding-top: 16px;
        border-top: 1px solid ${color("common.border")};

        @media print{
            display: none;
        }
    `,
};
